import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/`;
// const SERVER_URL = "http://localhost:3000/";



const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          تمایز لغات سخت
        </Typography>
        <Typography sx={{ p: 1 }}>
          برخی لغات با کمتر 10 بار مشاهده و تکرار آن به حافظه بلند مدت ما می روند و یادگیری آن برای ما آسان است ، عمدتا لغات سطح پایین به این صورت می باشند اما اینکه سطح یک لغت مبتدی و یا پیشرفته باشد لزوما به معنی آن نیست که ما آن لغت را با یک بار تکرار و یا چون سطح پیشرفته است با صد ها بار تکرار یاد میگیریم.
        </Typography>
        <Typography sx={{ p: 1 }}>
          این سختی در یاگیری برای افراد مختلف متفاوت می باشد ، لغتی که توسط شما با 5 بار تکرار فرا گرفته می شود، ممکن است توسط دوست شما نیاز به 150 بار تکرار و مطالعه داشته باشد.با توجه به استفاده از لایتنر برای یادگیری لغات ، این امکان برای ما فراهم شده که از طریق دیتای جعبه لایتنر شما لغاتی که یادگیری آن برای شما سخت می باشد را از دیگر لغات متمایز کرده و در برای هر کسی به صورت جداگانه این دیتا بصورت اختصاصی در اختیار شما قرار دهیم.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "60%" }} src={`${SERVER_URL}img/slider/slide6-img1.png`} />
        </Typography>
        <Typography sx={{ p: 1 }}>
          شما می توانید از این دیتا در جریان مشاهده فیلم با زیرنویس برای یادگیری بهتر این لغات استفاده کنید و از قابلیت های ویژه ای که در اختیار شما قرار گرفته یادگیری لغات سخت را برای خود تسهیل کنید.
        </Typography>
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          مرور لغات
        </Typography>
        <Typography sx={{ p: 1 }}>
          برای یادگیری یک لغت و ترجمه آن شما نیاز دارید که به دفعات آن را مرور کنید تا زمانی که لغت در حافظه کوتاه مدت شما قرار گیرد
        </Typography>
        <Typography sx={{ p: 1 }}>
          برای برخی از زبان آموزان مرور این لغات امری خسته کننده است و همچنین برای برخی دیگر بعد از حفظ نمودن لغت بصورت جداگانه وقتی آن را در درون جمله ای مشاهده می کنند نمی توانند ترجمه آن را به یاد آورند
        </Typography>
        <Typography sx={{ p: 1 }}>
          ما در اولنگ این امکان را فراهم کرده ایم که در طول مشاهده فیلم این لغات را نیز مرور کنید
        </Typography>
        <Typography sx={{ p: 1 }}>
          ضمن اینکه لغات در درون دیالگ ها به شما نشان داده می شوند که علاوه بر کمک در یادگیری سریعتر لغت ، شما را با کاربرد لغت در جملات آشنا می کند.</Typography>
      </DemoPaper>
    </>
  )
}


export default Slide1Content;
